module.exports = __webpack_public_path__ + "img/3.725d99a5.png";